import React from 'react'

import { Box, Typography, Button } from '@material-ui/core'
import { makeStyles } from '@material-ui/core/styles'
import WarningIcon from '@material-ui/icons/Warning'
import { Alert } from '@material-ui/lab'

const useStyles = makeStyles(() => {
  return {
    retryButton: {
      textTransform: 'initial',
    },
  }
})
interface ErrorAndRetryProps {
  action: () => void
}

const ErrorAndRetry: React.FC<ErrorAndRetryProps> = ({ action }) => {
  const classes = useStyles()
  return (
    <Box width="100%" pb={2} data-hook="empty-bonuses-alert">
      <Alert severity="error" icon={<WarningIcon fontSize="inherit" />}>
        Error al cargar los datos
      </Alert>
      <Box py={4}>
        <Button className={classes.retryButton} onClick={() => action()}>
          <Typography className="link" variant="body2">
            Reintentar
          </Typography>
        </Button>
      </Box>
    </Box>
  )
}

export default ErrorAndRetry
